// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, CopyButton, Group, Text, Tooltip } from '@mantine/core';
import { openModal } from '@mantine/modals';
import { IconBallpen, IconCheck, IconCopy, IconShare } from '@tabler/icons';
import { FC, useContext } from 'react';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { FormatS } from '../../../Service/FormatS';
import { RecruitmentCampaign } from '../../../Service/restapi/recruitmentService';
import EditCampaignModal from './EditCampaignModal';
import ShareCampaignModal from './ShareCampaignModal';

interface Props {
  campaign: RecruitmentCampaign;
  showRegistrations: boolean;
  showSales: boolean;
  handleChange: (patch: RecruitmentCampaign) => void;
}

const RecruitmentCampaignListItem: FC<Props> = ({ campaign, showRegistrations, showSales, handleChange }) => {
  const { id, name, registrations, earnedCredits } = campaign;
  const { profile } = useContext(ProfileContext);
  const campaignLink = `${process.env.REACT_APP_FRONTEND_URL}/register?campaign=${id}`;

  const shareCampaign = () => {
    openModal({
      title: (
        <Text weight="bolder" size="lg" sx={{ lineHeight: 1.2 }}>
          Einen Link teilen
        </Text>
      ),
      closeOnEscape: true,
      transition: 'slide-down',
      children: <ShareCampaignModal campaignId={id} userName={profile?.alias ?? ''} />,
    });
  };

  const editCampaign = () => {
    openModal({
      title: (
        <Text weight="bolder" size="lg" sx={{ lineHeight: 1.2 }}>
          Kampagne bearbeiten
        </Text>
      ),
      closeOnEscape: true,
      transition: 'slide-down',
      children: <EditCampaignModal campaign={campaign} handleChange={handleChange} />,
    });
  };

  return (
    <tr>
      <td>{name}</td>
      {showRegistrations && <td>{registrations}</td>}
      {showSales && <td>{FormatS.formatNumberCurrencyWithUnitSign(earnedCredits)}</td>}
      <td>
        <Group spacing={0} position="right">
          <ActionIcon onClick={editCampaign}>
            <IconBallpen size={20} />
          </ActionIcon>
          <CopyButton value={campaignLink} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Kopiert' : 'Link kopieren'} withArrow position="left" transition="slide-left">
                <ActionIcon onClick={copy}>
                  <ActionIcon>{copied ? <IconCheck color="teal" size={20} /> : <IconCopy size={20} />}</ActionIcon>
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
          <ActionIcon onClick={shareCampaign}>
            <IconShare size={20} />
          </ActionIcon>
        </Group>
      </td>
    </tr>
  );
};

export default RecruitmentCampaignListItem;
